import type { StoryboardSegment, StoryboardSegmentTask } from '../../types';

export const deriveActiveTasks = (segment: StoryboardSegment | null): StoryboardSegmentTask[] => {
  if (!segment) return [];
  const tasks = Array.isArray(segment.tasks) ? segment.tasks : [];
  const latestById = new Map<string, StoryboardSegmentTask>();
  for (const task of tasks) {
    if (!task || !task.taskId) {
      continue;
    }
    const existing = latestById.get(task.taskId);
    if (!existing || existing.updatedAt < task.updatedAt) {
      latestById.set(task.taskId, task);
    }
  }
  return [...latestById.values()]
    .filter((task) => task.status === 'queued' || task.status === 'generating')
    .sort((a, b) => a.submittedAt - b.submittedAt);
};
